module.exports = __webpack_public_path__ + "front/img/yqh04.ad93c1e0.png";